export function items(state) {
    return state.items;
}

export function totalItems(state) {
    let total = 0;
    if (state.items.length > 0) {

        state.items.forEach(function (item) {
            total += item.amount;
        })
    }
    return total
}

